// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slot-square {
  text-align: center;
  padding: 8px 10px;
  transition: all 0.2s ease-in-out;
  border: 1px solid #d1d1d1; /* Visible border */
  text-transform: uppercase;
  margin-bottom: 8px;
  cursor: pointer;
  border-radius: 50px; /* Full pill shape */
  color: #262626;
  font-family: AppFontMedium, sans-serif;
  font-size: 14px;
  background: white;
}
.slot-square.selected {
  color: white;
  background: var(--ion-color-primary) !important; /* Gold */
  border-color: var(--ion-color-primary);
}
.slot-square:hover {
  border-color: var(--ion-color-primary);
}

.slot-col {
  max-height: 200px; /* Constrain height */
  overflow-y: auto; /* Enable native scrolling */
}

.header-color {
  color: #262626;
  line-height: 17px;
  margin: 5px 0 10px;
  font-size: 12px;
  font-family: AppFontBold, sans-serif;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.no-padding {
  padding: 0px !important;
}

.smaller {
  font-size: 11px;
  padding: 16px 0px;
  text-transform: lowercase;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.hide-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}`, "",{"version":3,"sources":["webpack://./src/app/components/select-date-formcontrol/select-date-formcontrol.component.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,iBAAA;EACA,gCAAA;EACA,yBAAA,EAAA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA,EAAA,oBAAA;EACA,cAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;AADF;AAGE;EACE,YAAA;EACA,+CAAA,EAAA,SAAA;EACA,sCAAA;AADJ;AAIE;EACE,sCAAA;AAFJ;;AAMA;EACE,iBAAA,EAAA,qBAAA;EACA,gBAAA,EAAA,4BAAA;AAHF;;AAMA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;AAHF;;AAKA;EACE,uBAAA;AAFF;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;AADF;;AAGA;EACE,aAAA;AAAF;;AAEA;EACE,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AACF","sourcesContent":["@import \"../../../theme/mixins\";\n\n.slot-square {\n  text-align: center;\n  padding: 8px 10px;\n  transition: all 0.2s ease-in-out;\n  border: 1px solid #d1d1d1; /* Visible border */\n  text-transform: uppercase;\n  margin-bottom: 8px;\n  cursor: pointer;\n  border-radius: 50px; /* Full pill shape */\n  color: #262626;\n  font-family: AppFontMedium, sans-serif;\n  font-size: 14px;\n  background: white;\n\n  &.selected {\n    color: white;\n    background: var(--ion-color-primary) !important; /* Gold */\n    border-color: var(--ion-color-primary);\n  }\n  \n  &:hover {\n    border-color: var(--ion-color-primary);\n  }\n}\n\n.slot-col {\n  max-height: 200px; /* Constrain height */\n  overflow-y: auto; /* Enable native scrolling */\n}\n\n.header-color{\n  color: #262626;\n  line-height: 17px;\n  margin: 5px 0 10px;\n  font-size: 12px;\n  font-family: AppFontBold, sans-serif;\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: bold;\n}\n.no-padding{\n  padding: 0px !important;\n}\n.smaller{\n  font-size: 11px;\n  padding: 16px 0px;\n  text-transform: lowercase;\n}\n.hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n.hide-scrollbar {\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;  /* Firefox */\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
